import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import IAction from './IAction'

class Settings extends IAction {
    fn = () => {
        return this.props.onClick
    }
    icon = () => {
        return 'settings'
    }
    label = () => {
        return i18n.settings
    }

    id = () =>{
        return 'settings_action_navbar'
    }
}

Settings.propTypes = {
    onClick: PropTypes.func.isRequired,
}

export default Settings
